import * as types from './actionTypes';
import {api} from './api';
export function getProfile() {
    return api({
        types: [types.PROFILE__GET_REQUEST, types.PROFILE__GET_SUCCESS, types.PROFILE__GET_FAILURE],
        uri: '/api/profile',
        shouldCallAPI: () => true,
        config: {
            method: 'get',
            headers: {
                'Accept': 'application/json',
            },
        },
        payload: { }
    });
}

export function configureDelivery(options) {
    return { type: types.PROFILE__UPDATE_DELIVERY, options };
}

export function saveDeliveryOptions(profile) {
    return api({
        types: [types.PROFILE__SAVE_DELIVERY_REQUEST, types.PROFILE__SAVE_DELIVERY_SUCCESS, types.PROFILE__SAVE_DELIVERY_FAILURE],
        uri: '/api/profile/delivery',
        config: {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( profile )
        },
        payload: { profile }
    });
}
export function updateMobilePhone(profile) {
    return api({
        types: [types.PROFILE__UPDATE_MOBILE_PHONE_REQUEST, types.PROFILE__UPDATE_MOBILE_PHONE_SUCCESS, types.PROFILE__UPDATE_MOBILE_PHONE_FAILURE],
        uri: '/api/profile/phone',
        config: {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( profile )
        },
        payload: { profile }
    });
}

export function updateName(profile) {
    return api({
        types: [types.PROFILE__UPDATE_NAME_REQUEST, types.PROFILE__UPDATE_NAME_SUCCESS, types.PROFILE__UPDATE_NAME_FAILURE],
        uri: '/api/profile/name',
        config: {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( profile )
        },
        payload: { profile }
    });
}

export function updateDontShowAd(profile) {
    return api({
        types: [types.PROFILE__UPDATE_DONT_SHOW_AD_REQUEST, types.PROFILE__UPDATE_DONT_SHOW_AD_SUCCESS, types.PROFILE__UPDATE_DONT_SHOW_AD_FAILURE],
        uri: '/api/profile/advertisement',
        config: {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( profile )
        },
        payload: { profile }
    });
}